import React from "react";
import { Helmet } from "react-helmet-async";

const BASE = "https://enklamanualer.se";
const DEFAULT_IMAGE = `${BASE}/icon-512.png`;
const SITE_NAME = "Enkla Manualer";

export const Seo = ({
  title,
  description,
  path = "",
  type = "website",
  image = DEFAULT_IMAGE,
  noindex = false,
  jsonLd = null,
}) => {
  const url = `${BASE}${path}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="sv_SE" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(block)}</script>
      ))}
    </Helmet>
  );
};

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: BASE,
  logo: DEFAULT_IMAGE,
  email: "support@enklamanualer.se",
  description:
    "Enkla, pedagogiska manualer och personlig IT-hjälp för iPhone, iPad, MacBook, Windows, Smart-TV och tv-boxar.",
};

export const serviceJsonLd = ({ name, description, path, price }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: name,
  name,
  description,
  url: `${BASE}${path}`,
  areaServed: "SE",
  provider: { "@type": "Organization", name: SITE_NAME, url: BASE },
  ...(price
    ? { offers: { "@type": "Offer", price: String(price), priceCurrency: "SEK" } }
    : {}),
});

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${BASE}${it.path}`,
  })),
});

export { BASE, SITE_NAME, DEFAULT_IMAGE };
